module.exports = __webpack_public_path__ + "static/media/loading.3b468cca.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.gif
// module id = 29
// module chunks = 0